import type { ReactNode } from 'react';

export const symbol_no_drinks: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m564-482-42-42 102-111H411l-60-60h328l83-81H270l-64-64h587q19.92 0 32.46 13.81T838-795.21q0 8.21-3 16.14T826-764L564-482Zm-98-98ZM270-120q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h180v-245L82-792q-9-8.5-9-21.25T81.61-835q9.39-9 21.86-9 12.46 0 21.53 9l710 710q9 9 9 21t-9.05 21q-9.06 9-21.5 9Q801-74 792-83L511-364l-1 184h180q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H270Z"
		/>
	</svg>
);
